import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Profile Information", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle" }, " Please review and update the profile information below and click SAVE & NEXT to go to the next step. ", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-3" }
const _hoisted_8 = { class: "form-check-group" }
const _hoisted_9 = { class: "form-check-inline" }
const _hoisted_10 = {
  class: "form-check-label",
  for: "behalfOf"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name * ", -1)
const _hoisted_15 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name *", -1)
const _hoisted_19 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "ssn",
  class: "form-label"
}, "SSN *", -1)
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "dob",
  class: "form-label"
}, "Date Of Birth *", -1)
const _hoisted_29 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "form-label"
}, "Gender *", -1)
const _hoisted_34 = { class: "select-box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a Gender", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1)
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group mb-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "phoneNumber",
  class: "form-label"
}, "Phone Number ", -1)
const _hoisted_45 = {
  key: 2,
  class: "input-errors"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group mb-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "form-label"
}, "Country *", -1)
const _hoisted_50 = { class: "select-box" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a Country", -1)
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-group mb-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine1",
  class: "form-label"
}, "Address Line 1 *", -1)
const _hoisted_58 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group mb-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine2",
  class: "form-label"
}, "Address Line 2 ", -1)
const _hoisted_62 = {
  key: 2,
  class: "row"
}
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group mb-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "City *", -1)
const _hoisted_66 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "form-group mb-3" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "form-label"
}, "State *", -1)
const _hoisted_70 = { class: "select-box" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a State", -1)
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_74 = {
  key: 3,
  class: "row"
}
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group mb-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  for: "zipcode",
  class: "form-label"
}, "Zip Code *", -1)
const _hoisted_78 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  name: "submit",
  class: "d-none"
}, "Submit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)), ["prevent"]))
      }, [
        (_ctx.isFormInvalid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alert alert-danger",
              innerHTML: _ctx.validationMsg
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.enrollmentType === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otherApplicant) = $event)),
                          type: "checkbox",
                          class: "form-check-input",
                          id: "behalfOf"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.otherApplicant]
                        ]),
                        _createTextVNode(" I am enrolling as the spouse or child of the Primary ")
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.firstName) = $event)),
                maxlength: "50",
                type: "text",
                id: "firstName",
                class: _normalizeClass(["form-control", _ctx.v$.profile.firstName.$error ? 'is-invalid' : '']),
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.profile.firstName.$touch()))
              }, null, 34), [
                [_vModelText, _ctx.profile.firstName]
              ]),
              (_ctx.v$.profile.firstName.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_ctx.v$.profile.firstName.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.firstName.$error })
                        }, " Please enter a valid first name. ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.lastName) = $event)),
                maxlength: "50",
                type: "text",
                id: "lastName",
                class: _normalizeClass(["form-control", _ctx.v$.profile.lastName.$error ? 'is-invalid' : '']),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.profile.lastName.$touch()))
              }, null, 34), [
                [_vModelText, _ctx.profile.lastName]
              ]),
              (_ctx.v$.profile.lastName.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.v$.profile.lastName.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.lastName.$error })
                        }, " Please enter a valid last name. ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profile.ssn) = $event)),
                type: "text",
                "data-maska": "*##-##-####",
                id: "ssn",
                class: _normalizeClass(["form-control type-number", _ctx.v$.profile.ssn.$error ? 'is-invalid' : '']),
                disabled: _ctx.profile.originalEmployee,
                onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.profile.ssn.$touch()))
              }, null, 42, _hoisted_24), [
                [_vModelText, _ctx.profile.ssn],
                [_directive_maska]
              ]),
              (_ctx.v$.profile.ssn.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_ctx.v$.profile.ssn.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.ssn.$error })
                        }, " Please enter a valid SSN. ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profile.dob) = $event)),
                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.profile.dob.$touch())),
                class: _normalizeClass({
                'is-invalid': _ctx.v$.profile.dob.$error,
                'form-control': true,
              })
              }, null, 34), [
                [_vModelText, _ctx.profile.dob]
              ]),
              (_ctx.v$.profile.dob.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_ctx.v$.profile.dob.required.$invalid)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.dob.$error })
                        }, " Please enter a valid Date of Birth. ", 2))
                      : (_ctx.v$.profile.dob.customAge.$invalid)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.dob.$error })
                          }, " You must be at least 14 years old to proceed. ", 2))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.profile.genderId) = $event)),
                  class: _normalizeClass(["form-control", _ctx.v$.profile.genderId.$error ? 'is-invalid' : '']),
                  id: "gender",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.profile.genderId.$touch()))
                }, [
                  _hoisted_35,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderData, (gender) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: gender.genderId,
                      value: gender.genderId
                    }, _toDisplayString(gender.genderName), 9, _hoisted_36))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _ctx.profile.genderId]
                ])
              ]),
              (_ctx.v$.profile.genderId.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_ctx.v$.profile.genderId.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.genderId.$error })
                        }, " Please select the gender ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.profile.emailAddress) = $event)),
                type: "text",
                id: "email",
                class: "form-control",
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.profile.emailAddress]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              (_ctx.profile.countryId == _ctx.countries.OTH)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.profile.phoneNumber) = $event)),
                    type: "text",
                    id: "phoneNumber",
                    maxlength: "20",
                    class: _normalizeClass(["form-control type-number", _ctx.v$.profile.phoneNumber.$error ? 'is-invalid' : '']),
                    onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.profile.phoneNumber.$touch()))
                  }, null, 34)), [
                    [_vModelText, _ctx.profile.phoneNumber]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.profile.phoneNumber) = $event)),
                    type: "text",
                    id: "phoneNumber",
                    "data-maska": "###-###-####",
                    class: _normalizeClass(["form-control type-number", _ctx.v$.profile.phoneNumber.$error ? 'is-invalid' : '']),
                    onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.profile.phoneNumber.$touch()))
                  }, null, 34)), [
                    [_vModelText, _ctx.profile.phoneNumber],
                    [_directive_maska]
                  ]),
              (_ctx.v$.profile.phoneNumber.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    (_ctx.v$.profile.phoneNumber.validPhone)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.phoneNumber.$error })
                        }, " Please enter a valid phone number ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-control", _ctx.v$.profile.countryId.$error ? 'is-invalid' : '']),
                  id: "country",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.profile.countryId) = $event)),
                  onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changeCountry && _ctx.changeCountry(...args)))
                }, [
                  _hoisted_51,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCountries, (country) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: 'option-' + country.countryId,
                      value: country.countryId
                    }, _toDisplayString(country.countryName), 9, _hoisted_52))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _ctx.profile.countryId]
                ])
              ]),
              (_ctx.v$.profile.countryId.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    (_ctx.v$.profile.countryId.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.countryId.$error })
                        }, " Please select the country ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.profile.address1) = $event)),
                maxlength: "50",
                type: "text",
                id: "addressLine1",
                class: _normalizeClass(["form-control type-number", _ctx.v$.profile.address1.$error ? 'is-invalid' : '']),
                onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.v$.profile.address1.$touch()))
              }, null, 34), [
                [_vModelText, _ctx.profile.address1]
              ]),
              (_ctx.v$.profile.address1.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    (_ctx.v$.profile.address1.required)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.address1.$error })
                        }, " Please enter a valid address ", 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.profile.address2) = $event)),
                maxlength: "50",
                type: "text",
                id: "addressLine2",
                class: "form-control type-number",
                onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.setAddressDirty && _ctx.setAddressDirty(...args)))
              }, null, 544), [
                [_vModelText, _ctx.profile.address2]
              ])
            ])
          ])
        ]),
        (!_ctx.hideAddressFields)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.profile.city) = $event)),
                    maxlength: "50",
                    type: "text",
                    id: "city",
                    class: _normalizeClass(["form-control", _ctx.v$.profile.city.$error ? 'is-invalid' : '']),
                    onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.v$.profile.city.$touch()))
                  }, null, 34), [
                    [_vModelText, _ctx.profile.city]
                  ]),
                  (_ctx.v$.profile.city.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        (_ctx.v$.profile.city.requiredIfCountryNotOther)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.city.$error })
                            }, " Please enter the city ", 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.profile.geoStateId) = $event)),
                      class: _normalizeClass(["form-control", _ctx.v$.profile.geoStateId.$error ? 'is-invalid' : '']),
                      id: "state",
                      onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.profile.geoStateId.$touch()))
                    }, [
                      _hoisted_71,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allStatesOptions, (state) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'option-' + state.geoStateId,
                          value: state.geoStateId
                        }, _toDisplayString(state.geoStateName), 9, _hoisted_72))
                      }), 128))
                    ], 34), [
                      [_vModelSelect, _ctx.profile.geoStateId]
                    ])
                  ]),
                  (_ctx.v$.profile.geoStateId.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        (_ctx.v$.profile.geoStateId.requiredIfCountryNotOther)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.geoStateId.$error })
                            }, " Please select the state ", 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideAddressFields)
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.profile.zipCode) = $event)),
                    maxlength: "50",
                    type: "text",
                    id: "zipcode",
                    class: _normalizeClass(["form-control type-number", _ctx.v$.profile.zipCode.$error ? 'is-invalid' : '']),
                    onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.v$.profile.zipCode.$touch()))
                  }, null, 34), [
                    [_vModelText, _ctx.profile.zipCode]
                  ]),
                  (_ctx.v$.profile.zipCode.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        (
                  _ctx.v$.profile.zipCode.required || _ctx.v$.profile.zipCode.validZip
                )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ 'is-invalid': _ctx.v$.profile.zipCode.$error })
                            }, " Please enter a valid zip code ", 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_79
      ], 32)
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.common.saveNext,
      "is-form-invalid": _ctx.v$.profile.$invalid,
      "is-submit-disabled": _ctx.isSubmitDisabled,
      onSubmitHandler: _ctx.submitHandler,
      "tool-tip": "Please fill all required fields in order to proceed."
    }, null, 8, ["save-btn-txt", "is-form-invalid", "is-submit-disabled", "onSubmitHandler"])
  ], 64))
}